import dataConfig from "../baseConfig/dataConfig";
import eventConfig from "../baseConfig/eventConfig";

let AnalystManager = {};

/**
 * 上报路径
 * @param {*} toAction 
 * @param {*} cn 
 */
AnalystManager.browse = function (toAction, cn) {
    //渠道丢失处理
    var fullpath = toAction.path;
    if (toAction.path && !toAction.path.endsWith("/")) {
        fullpath += "/";
    }
    if (!cn) cn = window.queryParams['channel'];
    fullpath += cn + "/";

    if(window.isNewPlayer) fullpath +=  "today/";
    let auId = window.gtagId;
    if (!auId) auId = dataConfig.DEFAULT_GTAG_ID;
    gtag('config', auId, { 'page_path': fullpath });
}

/**
 * 上报事件
 * @param {*} self 
 * @param {*} event 
 * @param {*} action 
 * @param {*} label 
 */
AnalystManager.event = function(self , event , action , label , val) {
    let cn = self.$store.getters["common/getChannel"];
    let country = self.$store.state.common.country;
    event += "_" + cn + "_" + country;
    if (!label) label = cn;
    if (!val) val = 0;
    gtag('event', action, {
        'event_category': event,
        'event_label': label,
        'value': val
    });
}

/**
 * 记录初始化事件以及事件价值
 * @param {*} self 
 * @param {*} action 
 */
AnalystManager.initEvent = function(self , action) {
    let event = eventConfig.google.init.EVENT;
    let cn = self.$store.getters["common/getChannel"];
    let country = self.$store.state.common.country;
    event += "_" + cn + "_" + country;
    let val = 0;
    let now = Math.floor((new Date()).getTime() / 100);
    if (window.startInStamp) {
        val = now - window.startInStamp;
    }
    console.log(val + " >>>>>> time");
    gtag('event', action, {
        'event_category': event,
        'event_label': cn,
        'value': val
    });
}

/**
 * 设置操作的时间戳
 */
AnalystManager.updateActionStamp = function(action){
    let now = Math.floor((new Date()).getTime() / 100);
    window.localStorage.setItem(action + "-time" , now);
}

AnalystManager.getActionStamp = function(action){
    let now = Math.floor((new Date()).getTime() / 100);
    let last= window.localStorage.getItem(action + "-time");
    if (last) {
        return (now - parseInt(last));
    }
    return 0;
}

AnalystManager.uploadFacebookError = function(msg , tag){
    let arr = ["FacebookException" , "CANCEL"];
    for (let i = 0 ; i < arr.length ; i++) {
        if (tag.indexOf(arr[i]) != -1) {
            gtag('event', arr[i], {
                'event_category': "facebookError",
                'event_label': msg,
                'value': 0
            });
            return false;
        }
    }
    return true;
}

export default AnalystManager;


// WEBPACK FOOTER //
// ./src/utils/analyst.js